import "./css/IIITHMeetProgramLead.css";

const IIITHMeetProgramLead = () => {
  return (
    <div style={{ width: "100%" }}>
      <div
        className="intern-bg"
        style={{
          padding: "30px 10px",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h2 className="heading-text-3">Meet Program Lead</h2>
        <div
          className="row"
          style={{
            height: "100%",
            width: "80%",
            padding: "20px",
            boxShadow: "0px 2px 20px #bebebe",
            marginTop: "20px",
            display: "flex",
            gap: "20px",
            borderRadius: "20px",
            alignItems: "center",
            backgroundColor: "white",
            zIndex: 1,
          }}
        >
          {/* Left: Trainer Photo */}
          <div
            className="col-sm-12 col-md-4"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <img
              src="./IIITH/programLead.png" // Replace with actual path to Ishan's photo
              alt="Ishan Agarwal"
              style={{
                width: "200px",
                height: "200px",
                borderRadius: "50%",
                objectFit: "cover",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
              }}
            />
          </div>

          {/* Right: Trainer Info */}
          <div className="col-sm-12 col-md-7 about-para">
            <p>
              <b>Name:</b> Ishan Agarwal
            </p>
            <p>
              <b>College:</b> Rajiv Gandhi Institute of Petroleum Technology
            </p>
            <p>
              <b>Current Company:</b> Sophrosyne Semiconductors
            </p>
            <p>
              <b>Position:</b> Analog Design Engineer
            </p>
            <p>
              <a
                href="https://drive.google.com/file/d/1J-Tp7Y76HhPmcdPI5zd0sDMdm8lSAtSz/view?usp=drivesdk"
                target="_blank"
              >
                <button
                  style={{
                    background: "linear-gradient(to right, #4ECDC4, #2196F3)",
                    color: "white",
                    padding: "5px 20px",
                    borderRadius: "30px",
                    border: "none",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                  className="offer-letter-btn"
                >
                  Offer Letter after IIITH Selection
                </button>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IIITHMeetProgramLead;
